import { env } from '@hb/bridge-core';
import alipayMiniNative from './alipayMini';
import appNative from './app';
import browserNative from './browser';
import { INativeProxyCallNative } from './lib/interface';
import { addParams } from '../utils';
export function NativeProxyCallNative({
  method,
  params,
  classMap,
}: INativeProxyCallNative) {
  return new Promise((resolve, reject) => {
    // 小程序及IDE
    if (env.isAlipayMP) {
      return alipayMiniNative({ method, params, classMap })
        .then((result) => {
          resolve(result);
        })
        .catch((e) => {
          reject(e);
        });
    }
    if (env.isHelloBikeApp) {
      return appNative({ method, params, classMap })
        .then((result) => {
          resolve(result);
        })
        .catch((e) => {
          reject(e);
        });
    }
    // 默认都是H5
    return browserNative({ method, params })
      .then((result) => {
        resolve(result);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

// 助力车自定义native方法
function NativeProxy(this: any) {
  this.goLinkUrl = (url: string) =>
    NativeProxyCallNative({ method: 'goLinkUrl', params: url });

  this.redirectTo = async (
    url: string,
    isReplace = false,
    opts?: {
      needLogin: boolean;
    },
  ) => {
    const { needLogin = false } = opts || {};
    let newUrl = '';
    try {
      /* 在默认h5环境和需要登录的情况下给url拼接userInfo */
      if (needLogin && !(env.isAlipayMP || env.isHelloBikeApp)) {
        const userInfo = await browserNative({ method: 'getTokenAndKey' });
        newUrl = addParams(url, {
          ...userInfo,
        });
      } else {
        newUrl = url;
      }
    } catch (e) {
      newUrl = url;
      console.log('====>NativeProxy redirectTo err:', e);
    }
    if (!env.isAlipayMP && isReplace) {
      return window.location.replace(newUrl);
    }
    return NativeProxyCallNative({ method: 'redirectTo', params: newUrl });
  };

  this.goBack = (delta: number = 0) =>
    NativeProxyCallNative({ method: 'goBack', params: delta });

  this.closeWebView = () =>
    NativeProxyCallNative({
      method: 'closeWebView',
      params: '',
      classMap: 'SystemUtil',
    });
  this.getCityInfo = (forceShowDialog: boolean) =>
    NativeProxyCallNative({ method: 'getCityInfo', params: forceShowDialog });

  // 获取设备指纹
  this.getDeviceFingerprintHash = () =>
    NativeProxyCallNative({
      method: 'getDeviceFingerprintHash',
      params: null,
      classMap: 'SystemUtil',
    });

  // 显示或者隐藏原生的topbar，参数isShow,boolean类型 5.12.0之后版本可用
  this.showNaviBar = (show: boolean) =>
    NativeProxyCallNative({
      method: 'showNaviBar',
      params: show,
      classMap: 'NavBar',
    });

  // 调用扫码
  this.scanQRCode = () =>
    NativeProxyCallNative({ method: 'scanQRCode', params: null });

  // 设备标题
  this.setTitle = (title: string) =>
    NativeProxyCallNative({ method: 'setTitle', params: title });

  this.getTokenAndKey = (needLogin = true) =>
    NativeProxyCallNative({ method: 'getTokenAndKey', params: needLogin });

  this.setNavigationBar = (backgroundColor: string, title?: string) =>
    NativeProxyCallNative({
      method: 'setNavigationBar',
      params: { backgroundColor, title },
    });
  this.setStatusBar = (params: { isShowStatusBar: boolean }) =>
    NativeProxyCallNative({
      method: 'setStatusBar',
      params: params,
    });
  /** 选择图片 */
  this.chooseImage = (args?: any) =>
    NativeProxyCallNative({ method: 'chooseImage', params: args });
  /** 选择图片-新版 */
  this.chooseImageWithTips = (args?: any) =>
    NativeProxyCallNative({ method: 'chooseImageWithTips', params: args });
  /** 上传文件 */
  this.uploadFile = (url: string) =>
    NativeProxyCallNative({ method: 'uploadFile', params: url });

  // 保存图片功能
  this.savePicture = (base64Img: string) =>
    NativeProxyCallNative({
      method: 'savePicture',
      params: { base64Data: base64Img },
      classMap: 'SystemUtil',
    });
  // 由APP控制关闭webview
  this.closeWebViewByApp = () => {
    NativeProxyCallNative({
      method: 'evCallBackCloseH5',
      params: null,
      classMap: 'business/moped',
    }).then((data: any) => {
      if (data && data.data && data.data.close) {
        NativeProxyCallNative({
          method: 'closeWebView',
          params: '',
          classMap: 'SystemUtil',
        });
      }
    });
  };

  // 关闭webview
  this.closeWebView = () =>
    NativeProxyCallNative({
      method: 'closeWebView',
      params: null,
      classMap: 'SystemUtil',
    });

  // 打开新窗口跳转
  this.newOpenWebUrl = (params: {
    useRealm: boolean;
    hiddenNavigationBar: boolean;
    url: string;
    isClose: boolean;
    tenantId?: string;
  }): void => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    // Native.newOpenWebUrl(params);
    NativeProxyCallNative({
      classMap: 'oho_web_realm',
      method: 'newOpenWebUrl',
      params: {
        useRealm: params.useRealm,
        hiddenNavigationBar: params.hiddenNavigationBar,
        url: params.url,
        isClose: params.isClose,
        tenantId: params.tenantId,
      },
    });
  };

  this.realNameAuthentication = () => {
    NativeProxyCallNative({
      classMap: 'oho_web_h5',
      method: 'realNameAuthentication',
      params: null,
    });
  };

  this.getThirdAuthStatus = (tenantId: string) =>
    NativeProxyCallNative({
      classMap: 'business/thirdAuth',
      method: 'user_fetchThirdAuthStatus',
      params: {
        platform: tenantId,
      },
    });
}
// NativeProxy.prototype = Native;

export default new (NativeProxy as any)();

/**
 * 监听原生页返回到h5的方法
 * @param {*} callback 触发方法
 */
export const listenAppBackToH5 = (callback: () => void) => {
  const hiddenProperty =
    'hidden' in window.document
      ? 'hidden'
      : 'webkitHidden' in document
      ? 'webkitHidden'
      : 'mozHidden' in document
      ? 'mozHidden'
      : null;
  const toExcuteFunc = () => {
    // @ts-ignore
    if (!document[hiddenProperty]) {
      // 当从原生页面用户一系列操作后,返回H5的时候,这里会被触发
      callback();
      document.removeEventListener('visibilitychange', toExcuteFunc);
    }
  };
  document.addEventListener('visibilitychange', toExcuteFunc);
};
